module.exports = __webpack_public_path__ + "img/video.afe69f78.svg";